import { useAuthStore, useAuthUser } from "@/context/auth/AuthContext";

/** No tokens en keys. Una nueva sesión no reutiliza respuestas de la anterior. */
export function useBillingScope() {
  const user = useAuthUser();
  const session = useAuthStore((state: any) => state.billingSession);
  return [
    user?.organization?.id ?? null,
    user?.businessId ?? null,
    user?.id ?? null,
    user?.type ?? null,
    session,
  ] as const;
}
